import { Client, fetchExchange } from "urql";

import { CONTENTFUL_GRAPHQL_API_URL } from "@/utils/urls.ts";

import { RoadmapFeature } from "../types";

import { RoadmapFeaturesQuery } from "./gql";

export const ROADMAP_FEATURES_INITIAL_PAGE_SIZE = 50;
export const ROADMAP_FEATURES_ALL_ITEMS_PAGE_SIZE = 1000;

export const getContentfulDeliveryKey = () => {
    /* istanbul ignore next */
    return typeof window === "undefined"
        ? process.env["CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES"]
        : window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
};

const CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES = getContentfulDeliveryKey();

export interface RoadmapFeaturesQueryResult {
    roadmapFeatureCollection: {
        total: number;
        items: RoadmapFeature[];
    };
    taxonomyRoadmapAppCollection: {
        items: Array<{
            roadmapAppNameExternal: string;
            filterQueryParam: string;
        }>;
    };
    taxonomyRoadmapCategoryCollection: {
        items: Array<{
            roadmapCategoryNameExternal: string;
            queryParameter: string;
        }>;
    };
    taxonomyRoadmapStatusCollection: {
        items: Array<{
            roadmapStatusNameExternal: string;
        }>;
    };
}

export interface GetRoadmapFeaturesArgs {
    limit?: number;
    skip?: number;
    locale: string;
    roadmapName: RoadmapName;
}

export type RoadmapName = "Cloud" | "Data Center";

export const getRoadmapFeatures = async (args: GetRoadmapFeaturesArgs) => {
    const limit = args.limit;
    const skip = args.skip;
    const locale = args.locale;
    const roadmapName = args.roadmapName;

    const exchanges = [fetchExchange];

    const client = new Client({
        url: CONTENTFUL_GRAPHQL_API_URL,
        exchanges,
        fetchOptions: () => {
            return {
                headers: {
                    Authorization: `Bearer ${CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
                }
            };
        }
    });

    const queryVariables = {
        limit,
        skip,
        locale,
        roadmapNames: [roadmapName]
    };

    const data = await client.query(RoadmapFeaturesQuery, queryVariables);
    return data.data;
};
